import MuiMenuItem, { type MenuItemProps as MuiMenuItemProps } from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

import { colors, fonts } from '../../styles';

export interface MenuItemWithStyleProps {
  hasIconOnOptions?: boolean;
  disableMarginBetweenOptions?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const MenuItemWithStyle = withStyles({
  root: {
    padding: '16px 20px',
    margin: (props: MenuItemProps) => (props.disableMarginBetweenOptions ? '0' : '5px 0'),
    height: (props: MenuItemWithStyleProps) => (props.hasIconOnOptions ? 52 : 19),
    color: colors.gray.dark,
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.regular,
    lineHeight: 1.36,
    transition: 'background-color 0.4s ease-in-out',

    '&:hover': {
      backgroundColor: colors.gray.lightest,
    },

    '&:focus': {
      color: colors.gray.default,
    },
  },
})((props: MenuItemProps) => {
  const { hasIconOnOptions, ...otherProps } = props;

  delete otherProps.disableMarginBetweenOptions;
  otherProps.disableMarginBetweenOptions = undefined;
  return <MuiMenuItem {...otherProps} />;
});

// TODO: Wait for a MUI version that fixes this bug
// https://github.com/mui-org/material-ui/issues/16245
interface MenuItemProps extends MuiMenuItemProps {
  button?: true;
  hasIconOnOptions?: boolean;
  disableMarginBetweenOptions?: boolean;
}

export const MenuItem = (props: MenuItemProps) => {
  const { children, hasIconOnOptions, disableMarginBetweenOptions, ...otherProps } = props;

  return (
    <MenuItemWithStyle disableMarginBetweenOptions={disableMarginBetweenOptions} hasIconOnOptions={hasIconOnOptions} {...otherProps} button>
      {children}
    </MenuItemWithStyle>
  );
};
